import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  Leave,
  LeaveEntity,
  LeaveEntityDateRange,
} from "../../../../entriesAPI";
import ContinuePrevious from "../../LeaveDetailsComponents/DetailsParts/ContinuePrevious";
import PreviousLeaves from "../../LeaveDetailsComponents/DetailsParts/PreviousLeaves";
import LeaveEntityDateRangePicker from "../../../Shared/LeaveEntityDateRangePicker";

interface Props {
  leaveEntity: LeaveEntity;
  updateLeaveEntity: (
    key: string,
    value: string | LeaveEntityDateRange | null | Leave,
  ) => void;
  inputErrors: { [code: string]: boolean };
  setInputErrors: (inputErrors: { [code: string]: boolean }) => void;
    disableDatePicker: boolean;
}

const ToSickLeave = ({
  leaveEntity,
  updateLeaveEntity,
  inputErrors,
  setInputErrors,
                         disableDatePicker = false,
}: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          marginTop: "20px",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            fontSize: "16px",
            fontWeight: 400,
            color: "rgba(0, 0, 0, 0.52)",
            marginRight: "10px",
          }}
        >
          {t("hourEntries:absenceDate")}
        </Box>

        <LeaveEntityDateRangePicker
          dateRange={leaveEntity.dateRange}
          inputErrors={inputErrors}
          setInputErrors={setInputErrors}
          updateLeaveEntity={updateLeaveEntity}
          disabled={disableDatePicker}
        />
      </Box>

      <ContinuePrevious
        leaveEntity={leaveEntity}
        updateLeaveEntity={updateLeaveEntity}
      />

      {leaveEntity.previousLeaves.order.length > 0 && (
        <PreviousLeaves
          leaveEntity={leaveEntity}
          updateLeaveEntity={updateLeaveEntity}
        />
      )}
    </>
  );
};

export default ToSickLeave;
